import MotifHistoire from '@/views/consultations/en-cours/motif-histoire';

import ExamenClinique from '@/views/consultations/en-cours/examen-clinique';
import Constantes from '@/views/consultations/en-cours/constantes'

import HypotheseDiagnostic from '@/views/consultations/en-cours/hypothese-diagnostic';
import Diagnostic from '@/views/consultations/en-cours/diagnostics';

import ExamenBio from '@/views/consultations/en-cours/examen-bio';
import ExamenPara from '@/views/consultations/en-cours/examen-para';
import ProtocoleSoins from '@/views/consultations/en-cours/protocole-soins';
import OrdonnanceMedicale from '@/views/consultations/en-cours/ordonnance-medicale';

import CertifMedical from '@/views/consultations/en-cours/certif-medical';
import RendezVous from '@/views/consultations/en-cours/rendez-vous';
import FacteurPonderation from '@/views/consultations/en-cours/cpn/facteur-ponderation'
import ScorePonderation from '@/views/consultations/en-cours/cpn/score-ponderation'
import ConfirmFinConsultation from '@/views/consultations/en-cours/confirm-fin-consultation'
import Plaintes from '@/views/consultations/en-cours/plaintes'

// ATCD ENF
import ATCDENFPersonnel from '@/views/consultations/en-cours/antecedent-enf-personnel'
import ATCDENFFamiliaux from '@/views/consultations/en-cours/antecedent-enf-familiaux'

// ATCD Allergologie
import ATCDAllergoPersonnel from '@/views/consultations/en-cours/antecedent-allergologie-personnel'
import ATCDAllergoFamiliaux from '@/views/consultations/en-cours/antecedent-allergologie-familiaux'
import ATCDAllergoEnvironnement from '@/views/consultations/en-cours/antecedent-allergologie-environnement'

// ATCD Neonatologie
import ATCDNeonatologieGeniteur from '@/views/consultations/en-cours/antecedent-neonatologie-geniteur'

// ATCD Adulte
import ATCDAdultePersonnel from '@/views/consultations/en-cours/antecedent-adulte-personnel'
import ATCDAdulteFamiliaux from '@/views/consultations/en-cours/antecedent-adulte-familiaux'

// Histoire de la maladie - Anamnèse
import HistoireDelaMaladie from '@/views/consultations/en-cours/histoire-de-la-maladie'
import ConsultationCommentaire from '@/views/consultations/en-cours/consultation-commentaire'

import ManageEvolution from '@/views/consultations/en-cours/manage-evolution'
import VoirResultat from '@/views/analyse/visualiser-resultat';
import ExamenPreviewResult from '@/views/consultations/en-cours/examen-para/examen-preview-result'

// FEMME ENCEINTE
import Grossesse from '@/views/consultations/en-cours/grossesse'
import ExamenFemmeEnceinte from '@/views/consultations/en-cours/grossesse/examen-physique-fe'

import AcuiteVisuelle from '@/views/consultations/en-cours/ophtalmologie/acuite-visuelle'
import OrdonnaceDeLunettes from '@/views/consultations/en-cours/ophtalmologie/ordonnance-lunettes'

import ConsultationSections from '@/views/consultations/en-cours/consultation-sections'
import ChoixFicheConsultation from '@/views/consultations/en-cours/choix-fiche-consultation'
import CertificatsMedicaux from '@/views/consultations/en-cours/certificats-medicaux'

import DHIS2Diagnostics from '@/views/consultations/en-cours/dhis2-diagnostics'

import $ from 'jquery'
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import store_fiche from "@/store/mods/consultations/fiche-consultations"
import store_patient from '@/store/mods/patients/patient'

export default {
    name: 'en-cours',
    components: {
        MotifHistoire, ExamenClinique, HypotheseDiagnostic,
        ExamenBio, ExamenPara,
        OrdonnanceMedicale, CertifMedical, ProtocoleSoins,
        RendezVous, FacteurPonderation,
        ScorePonderation, ConfirmFinConsultation, Plaintes,
        Diagnostic, ATCDENFPersonnel, ATCDENFFamiliaux,
        ATCDAllergoPersonnel, ATCDAllergoFamiliaux, ATCDAllergoEnvironnement,
        ATCDNeonatologieGeniteur, ATCDAdultePersonnel,
        ATCDAdulteFamiliaux, HistoireDelaMaladie, Constantes, ConsultationCommentaire,
        ManageEvolution, VoirResultat, ExamenPreviewResult, ChoixFicheConsultation,
        Grossesse, ExamenFemmeEnceinte, AcuiteVisuelle, OrdonnaceDeLunettes,
        ConsultationSections, CertificatsMedicaux, DHIS2Diagnostics
    },

    props: {
        activeRole: String,
        user_id: Number,
        user_info: {
            type: Object,
            default: () => ({})
        },
        patient: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            vm_state: open_menu_state,
            analyse: true,
            examen: false,
            conduite: true,
            ordonnance: true,
            certificat: false,

            prescription_loading: true,
            examenbio_loading: true,
            consultation_id: null,
            exam_physique: [],

            end_loading: false,

            group_section_loading: true,
            section_is_loading: true,
            section_is_empty: false,
            selected_evolution: {},

            evolution_toggler: 0,
            toggler: 0,
            result_toggler: 0,
            info_resultat: {},
            demande_analyse: {},
            demande_examen: {},
            evolution_id: 0,

            // ==================================
            searchTerm: '',
            curr_type_consultation: "",
            consultation_group_sections: [],

            fiche_toggler: 0,
            fiche_id: 0,
            selected_fiche: '',
            info_consultation: {},
            fiche_sections: [],
            info_assurance_patient: {}
        }
    },

    computed: {
        active_group_sections() {
            return this.$store.getters["active_group_sections"];
        },

        demande_analyses() {
            return this.$store.getters["demandeAnalyses"];
        },

        liste_prescription() {
            return this.$store.getters["consultationOrdonnance"];
        },

        // consultation_id_to_pass() {
        //     return this.consultation_id;
        // },

        consultationEnCours() {
            return this.$store.getters['consultationPatientEnCours']
        },

        // exam_physique_to_pass: {
        //     get() {
        //         return this.exam_physique;
        //     },
        //     set(value) {
        //         this.exam_physique = value
        //     }
        // },

        // facteursPonderations() {
        //     return this.$store.getters["facteursPonderations"];
        // },

        evolution_id_initiale() {
            return this.$store.getters['evolution_id_initiale']
        },

        current_consultation_evolution() {
            return this.$store.getters['current_consultation_evolution']
        },

        selected_consultation_encours() {
            return this.$store.getters['selected_consultation_encours']
        }
    },
    mounted() {
        this.getConsultationEnCoursByTypeConsultation()

        this.getPatientInfoAssurance()

        const ts = this;
        $(document).bind("click", function (e) {
            const $clicked = $(e.target);
            if (!$clicked.parents().hasClass("drp-container")) {
                if (ts.vm_state != 0) {
                    ts.openMenu(ts.vm_state, 'drp-menu', 'animate-zoomIn', 'animate-zoomOut')
                }
            }
        });
    },

    methods: {
        // refreshConsultation() {
        //     this.getConsultationEnCoursByTypeConsultation()
        // },

        getConsultationEnCoursByTypeConsultation() {
            const param = {...this.selected_consultation_encours}

            this.$store.dispatch('getConsultationPatientEnCours', param).then((consultation) => {
                this.consultation_id = consultation.id
                this.curr_type_consultation = this.consultationEnCours?.tarif_consultation.type_consultation.nom
                this.fiche_id = this.consultationEnCours.fiche_consultation_id

                this.refreshListeFicheConsultationSection()

                // this.refreshActiveSection()

                this.getCurrentEvolution()
            })
        },

        getCurrentEvolution() {
            this.$store.dispatch('getCurrentConsultationEvolution', this.consultation_id)
        },

        /**
         * Open Menu Dropdown
         */
        async openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        refreshActiveSection() {
            this.$store.dispatch('getEvolutionIDInitiale').then(() => {
                // List of default active group_section
                let data = {
                    consultation_id: this.consultation_id,
                    groupe_id: this.evolution_id_initiale
                }
                this.refreshListOfActiveGroupSection(data)

                this.info_consultation.consultation_id = this.consultation_id
                this.info_consultation.evolution_id = this.evolution_id_initiale
            })
        },

        refreshSection(group_id) {
            this.evolution_toggler = (this.evolution_toggler === 0) ? 1 : 0
            if (this.evolution_id_initiale != group_id) {
                this.$store.commit('SET_EVOLUTION_ID_INITIALE', group_id)
                const data = {
                    consultation_id: this.consultation_id,
                    groupe_id: group_id
                }
                this.refreshListOfActiveGroupSection(data)
            }
        },

        addEvolution(evolution) {
            if (evolution == 0) {
                this.selected_evolution = {
                    groupe_id: 0
                }
            } else {
                this.selected_evolution = evolution
            }
        },

        refreshListConsultationGroupSection() {
            this.group_section_loading = true

            this.$store.dispatch('getListeConsultationGroupSection', this.consultation_id).then(() => {
                this.group_section_loading = false
            })
            this.refreshActiveSection()
            this.getCurrentEvolution()
        },

        refreshListeFicheConsultationSection() {
            this.group_section_loading = true

            const data = {
                fiche_id: this.fiche_id,
                user_id: this.user_id,
                consultation_id: this.consultationEnCours.id,
                type_consultation_id: this.consultationEnCours?.tarif_consultation.type_consultation.id
            }
            store_fiche.getListeFicheConsultationSection(data).then((response) => {
                this.info_consultation.fiche_id = response.fiche_id
                
                this.selected_fiche = response.fiche
                this.consultation_group_sections = response.groupe_section
                this.fiche_sections = this.consultation_group_sections[0].sections
                this.group_section_loading = false
            })

            this.refreshActiveSection()
            this.getCurrentEvolution()
        },

        refreshFicheConsultation(data) {
            this.fiche_id = data.fiche_id
            this.refreshListeFicheConsultationSection()
        },

        refreshListOfActiveGroupSection(data) {
            this.section_is_loading = true

            this.$store.dispatch('getListeOfActiveGroupSections', data).then(() => {
                if (this.active_group_sections.length == 0) {
                    this.section_is_empty = true
                } else {
                    this.section_is_empty = false
                }
                this.section_is_loading = false
            })
        },

        /**
         * Dis si la sage femme peut voir le score issu des facteurs de ponderation
         * @returns 
         */
        canSeeScore() {
            let err = false
            for (let i = 0; i < this.facteursPonderations.length; i++) {
                if (this.facteursPonderations[i].selected != null) {
                    err = true
                }
            }

            return err
        },

        addAnalyse() {

            this.analyse = true

            $('#stick-anchor').animate({
                scrollTop: $('#analyse').offset().top
            }, 800, function () { });
        },

        /**
         * Affiche la section CONDITION A TENIR
         */
        showCAT() {
            $('#stick-anchor').animate({
                scrollTop: $('#cat').offset().top
            }, 800, function () { });

            this.conduite = true;
        },

        /*
         *
         *Affiche la section ordonnance
         * 
         * */
        showOrdonnance() {
            this.ordonnance = true;

            $('#stick-anchor').animate({
                scrollTop: $('#ordonnance').offset().top
            }, 800, function () { });

        },

        endConsultation() {
            this.end_loading = true
            this.$store.dispatch("endConsultation", { consultation_id: this.consultationEnCours.id, date_rdv_to_send: '' }).then(() => {
                this.end_loading = false
                this.$router.push({ "path": "/dashboard" })
            })
        },

        reorder(evolution) {
            this.selected_evolution = evolution
        },

        /**
         * Visualiser résultat analyse bio
         * @param {*} param 
         */
        setOnGoingAnalyseResult(param) {
            this.toggler = (this.toggler == 0)?1:0
            this.demande_analyse = param.demande_analyse
            this.evolution_id = param.evolution_id
            setTimeout(() => {
                $('#modalResultat'+param.evolution_id).modal('show');
            }, 500);
        },

        /**
         * Visualiser résultat examen paraclinique
         * @param {*} param 
         */
        setOnGoingExamenParaResult(param) {
            this.result_toggler = (this.result_toggler == 0)?1:0
            this.demande_examen = param.result_preview
            this.info_resultat = param.info_resultat
            this.evolution_id = param.evolution_id
            setTimeout(() => {
                $('#view-result-examen'+param.evolution_id+param.info_resultat.demande_id).modal('show');
            }, 500);
        },

        browseFiche() {
            this.fiche_toggler = (this.fiche_toggler == 0)?1:0
            $('.browse-fiche').modal('show')
        },

        startConsultation() {
            this.fiche_toggler = (this.fiche_toggler == 0)?1:0
            $('.start-consultation').modal('show')
        },

        getPatientInfoAssurance() {
            store_patient.getInfoAssurancePatient(this.patient.id).then((response) => {
                this.info_assurance_patient = response
            })
        }
    }
}